const lodging = "lodging";
const poi = "poi";
const partnerActivity = "partner_activity";
const articles = "articles";
const availability = "availability";
const collections = "collections";
const narrative = "narrative";
const narratives = "narratives";

const resourceTypes = {
  availability,
  lodging,
  poi,
  articles,
  partner_activity: partnerActivity,
  collections,
  narrative,
  narratives,
};

export default resourceTypes;



// WEBPACK FOOTER //
// ../server/lib/open-planet/resourceTypes.js